export const visit = (vm, at) => {
at({ "ja": { "priceComponents": { "pricePerMonth": "{{price}}\uFF0F\u6708", "pricePerMonthPerSeat": "{{price}}\uFF0F\u6708\uFF0F\u30B7\u30FC\u30C8", "pricingLabel": "{{name}}\u306E\u6599\u91D1", "subtexts": { "startsAt": "\u6700\u4F4E\u5229\u7528\u6599\u91D1\uFF1A" } } } });
};